import { graphql, useStaticQuery } from "gatsby";

/**
 * Sorgente unica ("setup dedicato") dei token globali della ACF Options page
 * "Privacy":
 * - @@privacy@@        → WYSIWYG (testoPrivacy), testo completo dell'informativa
 *   iniettato nel CORPO dei popup;
 * - @@privacy-title@@  → text (titoloPrivacy), titolo breve iniettato nel TITOLO
 *   dei popup (vedi ModalService).
 *
 * NB: doppio annidamento `acfOptionsPrivacy { acfOptionsPrivacy { ... } }`
 * come per `acfOptionsRichiestaFattibilita` (options page → field group).
 */
export const useStaticQueryPrivacy = () => {
  const { wp } = useStaticQuery(graphql`
    query privacyQuery {
      wp {
        acfOptionsPrivacy {
          acfOptionsPrivacy {
            privacy {
              testoPrivacy
              titoloPrivacy
            }
          }
        }
      }
    }
  `);

  const data = wp?.acfOptionsPrivacy?.acfOptionsPrivacy?.privacy;

  return {
    privacy: data?.testoPrivacy || null,
    privacyTitle: data?.titoloPrivacy || null,
  };
};
